<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('EMPLOYEES.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="indigo"
        @click="$router.push({ name: 'employees.create' })"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('EMPLOYEES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-row>
        <v-col cols="12">
          <v-col cols="12">
            <employees-list-filters @setFilters="setFilters" />
          </v-col>
        </v-col>
        <v-col cols="12">
          <employees-list :items="items" :meta="meta" :options.sync="options" />
        </v-col>
      </v-row>
      <v-row>
        <v-btn @click="getEmployeesExportFile">{{ $t('BUTTON.EXPORT') }}</v-btn>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import downloadFile from '@/modules/_global/mixins/download-file';
import EmployeesList from '../components/EmployeesList';
import EmployeesListFilters from '@/modules/employees/components/EmployeesListFilters';
import { EmployeesService } from '@/services/employees.service';
import { dateFormatUnderscore } from '@/modules/_global/filters';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'EmployeesPage',

  components: {
    EmployeesListFilters,
    EmployeesList,
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [downloadFile, listOptions],

  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['last_name'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      error: null,
      employees: [],
      meta: {}
    };
  },

  computed: {
    ...mapState('employee', ['paginationOptions'])
  },

  methods: {
    ...mapActions('employee', ['getItemsList']),

    getEmployeesExportFile() {
      EmployeesService.export(this.filters)
        .then(response => {
          const filename = this.$t('EMPLOYEES.ITEMS');
          const date = dateFormatUnderscore(new Date());

          this.downloadFile(response, `${filename} ${date}.xlsx`);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
